// extracted by mini-css-extract-plugin
export var chip = "_bo-0";
export var filterDropdown = "_bo-5";
export var filterItem = "_bo-6";
export var icon = "_bo-1";
export var removeButton = "_bo-3";
export var removeIcon = "_bo-4";
export var separator = "_bo-2";